import VueGoogleMaps from 'vue-google-maps-community-fork';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const currentPath = nuxtApp.$router.currentRoute.value.path;
  const isCheckoutRoute = currentPath.startsWith('/shop/checkout');
  const googleApiKey = isCheckoutRoute ? config.public.googleApiKey2 : config.public.googleApiKey;

  if (!googleApiKey) {
    return;
  }

  if (import.meta.client) {
    window.gm_authFailure = () => {
      window.dispatchEvent(new CustomEvent('google-maps-auth-error'));
    };
  }

  nuxtApp.vueApp.use(VueGoogleMaps, {
    load: {
      key: googleApiKey,
      libraries: 'places',
    },
  });
});